import { UPDATE_SELECTED_BATCH_CLAIMS} from "./actions";

const initialState = {
  selected_batch_claims: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case UPDATE_SELECTED_BATCH_CLAIMS:
      return Object.assign({}, state, {
        selected_batch_claims: action.payload
      });

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/submit_claims/recent_batch/Reducer.Recent_Batches.js